// extracted by mini-css-extract-plugin
module.exports = {"expanded":"cell_expanded__32MI0"};